/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React from 'react';
import { Input } from 'semantic-ui-react';

class LabeledInput extends React.Component {
    render() {
        const { labelText = '', labelPosition = 'right' } = this.props;

        return <Input label={{ basic: true, content: labelText }} labelPosition={labelPosition} {...this.props} />;
    }
}

export default LabeledInput;
